import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const GearOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function GearOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fillRule="evenodd" clipRule="evenodd" fill="currentColor">
          <path d="M8 11.995c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4Zm6 0c0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2 1.11 0 2-.89 2-2Z" />
          <path d="M10 .995h4v.01l1.53 2.65 1.47.85h3.5l2.25 3.89-1.81 3.14.04 1.55 1.55 2.69-2.03 3.73h-3.68l-1.2.69-1.62 2.81h-4l-1.53-2.65-1.47-.85H3.5l-2.25-3.89 1.81-3.14-.04-1.56-1.55-2.69 2.03-3.73h3.68l1.2-.69L10 .995Zm3.8 3.65-.96-1.65-.01-.01h-1.69l-1.04 1.81-.27.46-.46.27-1.2.69-.46.27H4.68l-.92 1.7.99 1.72.27.44v.51l.06 1.56v.56l-.28.49-1.23 2.14 1.09 1.89h2.88l.46.27 1.47.85.46.27.27.46.96 1.65h1.69l1.05-1.81.27-.46.46-.27 1.2-.69.46-.27h3.03l.92-1.7-.99-1.72-.27-.44v-.51l-.06-1.55v-.56l.28-.49 1.23-2.14-1.09-1.89h-2.88l-.46-.27-1.47-.85-.46-.27-.27-.46Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default GearOutlined;